import clsx from 'clsx';
import { IconButton } from './Button/IconButton';
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface DrawerProps {
  header: React.ReactNode | string;
  children: React.ReactNode;
  className?: string;
}

export const Drawer = ({ header, children, className }: DrawerProps) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={clsx('flex flex-col w-full', className)}>
      <div className="grid grid-cols-[1fr,40px] items-center w-full min-h-[40px]">
        <div className="items-center text-darkMode-gray-medium font-bold text-lg">{header}</div>
        <div className="flex items-center justify-center">
          <IconButton
            onClick={() => setIsOpen(!isOpen)}
            className={clsx('transition-transform duration-200 text-palette-700', {
              '-rotate-90': !isOpen,
            })}
            icon="chevronDown"
          />
        </div>
      </div>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className="overflow-hidden"
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
